"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    requiredCourses: {
        'found of person fitness': 1,
        'lifetime rec/outdoor pursuits': 1,
        'aerobic activities': 1,
        'individual or team sports': 1,
        'pe sub athletics 1': 1,
        'pe sub athletics 2': 1,
        'pe sub athletics 3': 1,
        'pe sub athletics 4': 1,
        'pe sub cheerleading': 1,
        'pe sub drill team': 1,
        'pe sub jrotc1': 1,
        'pe sub marching band': 1,
        'pe sub non-dist pgm 1': 1,
        'pe sub non-dist pgm 2': 1,
        'pe sub non-dist pgm 3': 1,
        'pe sub non-dist pgm 4': 1,
        'pe substitution teks': 1,
        /* new courses added 2018-06-26 */
        "substitution academic elective": 1,
    }
};
//# sourceMappingURL=pe.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/pe.js
// module id = 448
// module chunks = 22